import { useEffect, useState } from "react";
import tenantConfigs from "../config/tenantsConfig.json";
import { getTenantSubdomain } from "../util/tenantUtil";

export default function PrivacyPolicy() {
  const [tenantPolicy, setTenantPolicy] = useState({
    appName: "Universal Stream",
    developer: "Lotus Entertainment",
    website: "https://universal.multiapp.ac",
  });

  useEffect(() => {
    const tenant = getTenantSubdomain();

    const policy =
      tenantConfigs[tenant]?.policy || tenantConfigs.default.policy;

    setTenantPolicy(policy);
  }, []);

  return (
    <div className="bg-gray-50 text-gray-900 dark:bg-gray-900 dark:text-gray-100 px-4 py-12">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <header className="text-center mb-12">
          <h1 className="text-4xl font-extrabold mb-3 text-blue-600 dark:text-blue-400">
            Privacy Policy – {tenantPolicy.appName}
          </h1>

          <p className="text-sm text-gray-600 dark:text-gray-300">
            Last updated: <span className="font-medium">18-06-2025</span>
          </p>
        </header>

        <div className="space-y-12">
          {/* Intro */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <p className="mb-4">
              This Privacy Policy applies to the <b>{tenantPolicy.appName}</b>{" "}
              mobile application developed by <b>{tenantPolicy.developer}</b>.
            </p>

            <p>
              {tenantPolicy.appName} is a platform that allows users to join
              live meetings, online sessions, and virtual classes across
              multiple devices. This policy explains how we collect, use, and
              protect your information when you use the {tenantPolicy.appName}{" "}
              app.
            </p>
          </section>

          {/* Developer Details */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Developer Information
            </h2>

            <p>
              App Name: {tenantPolicy.appName}
              <br />
              Developer: {tenantPolicy.developer}
              <br />
              Website: {tenantPolicy.website}
            </p>
          </section>

          {/* Data Collection */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Information We Collect
            </h2>

            <ul className="list-disc list-inside space-y-2">
              <li>Email address and login information</li>

              <li>Device information (device model, OS version)</li>

              <li>IP address</li>

              <li>App usage information</li>
            </ul>
          </section>

          {/* Usage */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              How We Use Information
            </h2>

            <ul className="list-disc list-inside space-y-2">
              <li>Provide access to live sessions and meetings</li>

              <li>Improve app performance</li>

              <li>Maintain security</li>

              <li>Provide customer support</li>
            </ul>
          </section>

          {/* Sharing */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Data Sharing
            </h2>

            <p>
              {tenantPolicy.appName} does not sell personal information.
              Information may be shared only when required by law or to provide
              app functionality.
            </p>
          </section>

          {/* Security */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Data Security
            </h2>

            <p>
              We take reasonable measures to protect your information from
              unauthorized access or disclosure.
            </p>
          </section>

          {/* Children */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Children's Privacy
            </h2>

            <p>
              {tenantPolicy.appName} does not knowingly collect personal
              information from children under 13 years of age.
            </p>
          </section>

          {/* Updates */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Changes to This Policy
            </h2>

            <p>
              We may update this Privacy Policy from time to time. Updates will
              be posted on this page.
            </p>
          </section>

          {/* Contact */}
          <section className="bg-white dark:bg-gray-800 shadow-md rounded-xl p-6">
            <h2 className="text-2xl font-bold mb-4 text-blue-600 dark:text-blue-400">
              Contact Us
            </h2>

            <p>
              If you have questions about this Privacy Policy, you can contact:
              <br />
              {tenantPolicy.developer}
              <br />
              Website: {tenantPolicy.website}
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
